import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export function WheelChart({ labels, values, goalValues }) {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Check initial theme
    const checkTheme = () => {
      setIsDark(document.documentElement.classList.contains('dark'));
    };
    checkTheme();

    // Listen for theme changes
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    
    return () => observer.disconnect();
  }, []);

  const textColor = isDark ? 'hsl(210, 40%, 90%)' : 'hsl(210, 15%, 14%)';
  const gridColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)';
  const tooltipBg = isDark ? 'hsl(220, 18%, 20%)' : 'hsl(210, 15%, 14%)';

  const data = {
    labels,
    datasets: [
      {
        label: 'Mi Rueda de la Vida',
        data: values,
        fill: true,
        backgroundColor: 'hsla(188, 55%, 34%, 0.15)',
        borderColor: 'hsl(188, 55%, 34%)',
        borderWidth: 2,
        pointBackgroundColor: 'hsl(188, 55%, 34%)',
        pointBorderColor: isDark ? '#1a1a2e' : '#fff',
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
      },
      ...(goalValues
        ? [
            {
              label: 'Meta',
              data: goalValues,
              fill: false,
              borderDash: [6, 4],
              borderColor: 'hsl(202, 56%, 36%)',
              borderWidth: 2,
              pointBackgroundColor: 'hsl(202, 56%, 36%)',
              pointBorderColor: isDark ? '#1a1a2e' : '#fff',
              pointBorderWidth: 2,
              pointRadius: 4,
            },
          ]
        : []),
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        min: 0,
        max: 10,
        ticks: {
          stepSize: 1,
          backdropColor: 'transparent',
          font: {
            size: 10,
          },
          color: textColor,
        },
        grid: {
          color: gridColor,
        },
        pointLabels: {
          font: {
            size: 11,
            weight: '500',
          },
          color: textColor,
        },
        angleLines: {
          color: gridColor,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: tooltipBg,
        titleFont: {
          size: 13,
        },
        bodyFont: {
          size: 12,
        },
        padding: 10,
        cornerRadius: 8,
      },
    },
    elements: {
      line: {
        tension: 0.35,
      },
    },
  };

  return (
    <div className="h-80 sm:h-96 w-full" data-testid="wheel-chart-canvas">
      <Radar data={data} options={options} key={isDark ? 'dark' : 'light'} />
    </div>
  );
}

export default WheelChart;
